import React from 'react';
import { LazyImage } from "component/index";
import CloseIcon from "assets/icon/CloseIcon";
import 'component/fullScreenMedia/fullScreenMedia.scss';
function FullScreenMedia(_a) {
    var source = _a.source, alt = _a.alt, videoThumbnail = _a.videoThumbnail, sourceType = _a.sourceType, onClose = _a.onClose;
    return (React.createElement("div", { className: 'w-full h-full flex top-0 left-0 justify-center items-center fixed z-70', onClick: onClose },
        React.createElement("div", { className: 'w-full h-full flex top-0 left-0 bg-black opacity-80 fixed' }),
        React.createElement("div", { className: 'w-auto h-auto relative flex flex-col justify-start' },
            React.createElement(CloseIcon, { className: 'w-8 h-8 text-white cursor-pointer', onClick: function (e) {
                    e.stopPropagation();
                    onClose();
                } }),
            React.createElement("div", { className: 'w-full h-full', onClick: function (e) { return e.stopPropagation(); } },
                sourceType === 'image' &&
                    React.createElement(LazyImage, { dataSrc: source, defaultImage: source, noScriptSrc: source, className: 'w-full h-full imageSize z-20', alt: alt || 'image' }),
                sourceType === 'video' &&
                    React.createElement("video", { id: "my-video", className: 'w-full h-full', controls: true, autoPlay: false, preload: "auto", poster: videoThumbnail || '', "data-setup": "{}" },
                        React.createElement("source", { src: source, type: "video/webm" }),
                        React.createElement("source", { src: source, type: "video/mp4" }))))));
}
export default FullScreenMedia;
